
import KTDropdownNotification from "@/view/layout/extras/dropdown/DropdownNotification.vue";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import EmpresaSelector from "@/view/layout/header/EmpresaSelector.vue";
import { notificationStore } from "../../../notificationStore";
import swal from "sweetalert";
import { SistemaMixin } from "@/modules/Application";
import AccountCircle from "vue-material-design-icons/AccountArrowRightOutline.vue";
import JwtService from "@/core/services/jwt.service";
import { mapGetters, mapState } from "vuex";

export default {
  name: "KTTopbar",
  data() {
    return {
      notificationStore,
      souRevenda: false,
      searchQuery: "",
      clients: [],
      selectedClient: null,
    };
  },
  mixins: [SistemaMixin],
  components: {
    KTDropdownNotification,
    KTQuickUser,
    AccountCircle,
    EmpresaSelector,
  },
  methods: {
    normalizeSearchText(value) {
      return String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();
    },
    onlyDigits(value) {
      return String(value || "").replace(/\D/g, "");
    },
    resolveRevendaFromUser(user) {
      return (
        user?.isRevenda === true ||
        user?.is_revenda === true ||
        user?.empresa?.revenda === true ||
        user?.usuario_empresa?.empresa?.revenda === true ||
        Boolean(user?.empresa?.dados_revenda)
      );
    },
    getRevendaId(user) {
      const parceiro = user?.usuario_empresa?.empresa?.parceiro || {};
      const idRevendaDireto =
        parceiro?.id_revenda ??
        user?.idRevenda ??
        user?.id_revenda ??
        user?.empresa?.idRevenda ??
        user?.empresa?.id_revenda ??
        null;

      if (Number(idRevendaDireto) === 1) {
        return (
          parceiro?.id_empresa ??
          user?.empresa?.id_empresa ??
          user?.usuario_empresa?.id_empresa ??
          null
        );
      }

      return (
        idRevendaDireto ??
        parceiro?.id_empresa ??
        user?.empresa?.id_empresa ??
        user?.usuario_empresa?.id_empresa ??
        null
      );
    },
    async atualizarContextoRevenda(user) {
      const contextoParceiro =
        JwtService.getParceiro() === "true" ||
        JwtService.getParceiro() === true;

      this.souRevenda = this.isRevenda === true || contextoParceiro;

      if (!this.souRevenda) {
        this.clients = [];
        return;
      }

      const id_revenda = this.getRevendaId(user);
      if (!id_revenda) {
        this.clients = [];
        return;
      }

      try {
        const data = await this.$http.post("/empresa/meus-clientes-lista", {
          id_revenda,
        });
        this.clients = data?.data || [];
      } catch (e) {
        this.clients = [];
      }
    },
    selectClient(client) {
      this.selectedClient = client.id_empresa;
      this.searchQuery = client.cliente;

      swal({
        icon: "warning",
        title: "Deseja acessar a conta do cliente " + client.cliente + "?",
        showCancelButton: true,
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Sim",
            visible: true,
            closeModal: false,
          },
        },
        confirmButtonColor: "#f64e60",

        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        swal.close();
        swal.stopLoading();

        this.$toast.success(
          "Aguarde, carregando os dados referente ao clente..."
        );

        const response = await this.$http.post("/empresa/acessar-conta", {
          id_empresa: client.id_empresa,
          id_revenda: client.id_revenda,
        });

        if (response) {
          JwtService.saveTokenCliente(response.data.access_token);
          JwtService.saveEmpresaId(client.id_empresa);
          JwtService.saveParceiro(true);
        }

        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
    },
  },
  watch: {
    async currentUser(user) {
      await this.atualizarContextoRevenda(user);
    },
  },
  computed: {
    ...mapGetters(["isRevenda"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    filteredClients() {
      const query = this.normalizeSearchText(this.searchQuery);
      const queryDigits = this.onlyDigits(this.searchQuery);

      if (!query && !queryDigits) return this.clients;

      return this.clients.filter((client) => {
        const nome = this.normalizeSearchText(client?.cliente);
        const documento = String(client?.cnpj_cpf || "");
        const documentoDigits = this.onlyDigits(documento);

        const matchNome = query ? nome.includes(query) : false;
        const matchDocumentoTexto = query ? documento.includes(query) : false;
        const matchDocumentoDigitos = queryDigits
          ? documentoDigits.includes(queryDigits)
          : false;

        return matchNome || matchDocumentoTexto || matchDocumentoDigitos;
      });
    },
  },
  async mounted() {
    await this.atualizarContextoRevenda(this.currentUser);
  },
};
